var link_viewer_default = {
  "fontElementMap": "MP0yg",
  "link": "_3mPCj",
  "linkInEditor": "q2XJg",
  "linkInViewer": "uUNDj",
  "toolbarUrlContainer": "EuNmJ",
  "toolbarUrl": "QjS8-",
  "toolbarUrlAnchor": "DdpWo"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
